import { Flex } from "components/Flex";
import { Typography } from "components/Typography";
import { cssColor, firstLetters, makeBEM } from "utils";

import "./index.scss";

export interface AvatarProps {
  avatar?: string;
  fullName?: string;
  email?: string;
  size?: "small" | "big";
  type?: "primary" | "secondary";
}

const bem = makeBEM("avatar");

export const Avatar: React.FC<React.PropsWithChildren<AvatarProps>> = ({
  avatar,
  fullName,
  email,
  size = "small",
  type = "primary",
  children,
}) => {
  const firstLettersText = firstLetters(fullName);
  return (
    <Flex justify="center" align="center" wrap className={bem()} gap={16}>
      <div className={bem("icon", [size, type])}>
        {avatar ? (
          <img src={avatar} alt="User Avatar" />
        ) : (
          <Typography fw={700} size={size === "small" ? "1rem" : "1.5rem"}>
            {firstLettersText}
          </Typography>
        )}
      </div>
      {children !== null && (
        <div>
          {children ? (
            children
          ) : (
            <Flex direction="column" justify="center" gap={8}>
              {fullName && (
                <Typography fw={700} size="1.72rem" uppercase type="h1" style={{ wordBreak: "break-all" }}>
                  {fullName}
                </Typography>
              )}
              {email && (
                <Typography color={cssColor("primary-500")} size="0.9rem">
                  {email}
                </Typography>
              )}
            </Flex>
          )}
        </div>
      )}
    </Flex>
  );
};
